<template>
  <div
    class="text-[var(--foreground)] dark:bg-[var(--color-1)] dark:bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] bg-[#eaeaea] overflow-hidden relative"
  >
    <div class="pt-10">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
const hydrated = ref(false);
onMounted(() => {
  hydrated.value = true;
});
</script>
